/* eslint-disable import/no-cycle */
import { 	
	addIsSyncing, 
	removeIsSyncing, 
	clearIsSyncing,
	
	addIsUnsyncing, 
	removeIsUnsyncing, 
	clearIsUnsyncing,
	
	addIsDeleting, 
	removeIsDeleting, 
	clearIsDeleting,

	addIsDeleted,
	removeIsDeleted,
	clearIsDeleted,
	
	addIsQueuedForDelete, 
	removeIsQueuedForDelete, 
	clearIsQueuedForDelete,
	
	addIsSelected, 
	removeIsSelected, 
	clearIsSelected,

	setAutoFixStore,
	addAutoFixPmCt,
	removeAutoFixPmCt,
	clearAutoFixPmCt,
	setAutoFixIsFixing,
	setAutoFixIsStopping,

	// CACHED JOBS - Component JobList Local State Cache - CISV JobList component manages state locally, this allows us to cache that local state in redux and make it available to our selectors.
	setJobListTab,
	setFJobs,
	setSJobs,

	addErrorMessages,
	removeErrorMessages,
	clearErrorMessages,
	
	clear,
 } from './actions';

 import { 
	thunkUnsyncSurveys,
	thunkSyncSurveys,
	thunkDeleteSurveys,
	thunkDeleteAllReadings,
	thunkToggleAllIsSelected,

	thunkSetJobsListTab,
	thunkSetFJobs,
	thunkSetSJobs,
	thunkForceComputeAutoFixStore,
	thunkStartAutoFix,
	thunkStopAutoFix,
} from './thunks';

 
export {
	addIsSyncing, 
	removeIsSyncing, 
	clearIsSyncing,
	
	addIsUnsyncing, 
	removeIsUnsyncing, 
	clearIsUnsyncing,
	
	addIsDeleting, 
	removeIsDeleting, 
	clearIsDeleting,
	
	addIsDeleted,
	removeIsDeleted,
	clearIsDeleted,

	addIsQueuedForDelete, 
	removeIsQueuedForDelete, 
	clearIsQueuedForDelete,
	
	addIsSelected, 
	removeIsSelected, 
	clearIsSelected,

	setAutoFixStore,
	addAutoFixPmCt,
	removeAutoFixPmCt,
	clearAutoFixPmCt,

	addErrorMessages,
	removeErrorMessages,
	clearErrorMessages,
	setAutoFixIsFixing,
	setAutoFixIsStopping,

	setJobListTab,
	setFJobs,
	setSJobs,

	clear,

	thunkUnsyncSurveys,
	thunkSyncSurveys,
	thunkDeleteSurveys,
	thunkDeleteAllReadings,
	thunkToggleAllIsSelected,

	thunkSetJobsListTab,
	thunkSetFJobs,
	thunkSetSJobs,
	thunkForceComputeAutoFixStore,
	thunkStartAutoFix,
	thunkStopAutoFix,
};


export default {
	addIsSyncing, 
	removeIsSyncing, 
	clearIsSyncing,
	
	addIsUnsyncing, 
	removeIsUnsyncing, 
	clearIsUnsyncing,
	
	addIsDeleting, 
	removeIsDeleting, 
	clearIsDeleting,
	
	addIsQueuedForDelete, 
	removeIsQueuedForDelete, 
	clearIsQueuedForDelete,
	
	addIsSelected, 
	removeIsSelected, 
	clearIsSelected,

	setAutoFixStore,
	addAutoFixPmCt,
	removeAutoFixPmCt,
	clearAutoFixPmCt,

	addErrorMessages,
	removeErrorMessages,
	clearErrorMessages,
	setAutoFixIsFixing,
	setAutoFixIsStopping,

	setJobListTab,
	setFJobs,
	setSJobs,

	clear,

	thunkUnsyncSurveys,
	thunkSyncSurveys,
	thunkDeleteSurveys,
	thunkDeleteAllReadings,
	thunkToggleAllIsSelected,

	thunkSetJobsListTab,
	thunkSetFJobs,
	thunkSetSJobs,
	thunkForceComputeAutoFixStore,
	thunkStartAutoFix,
	thunkStopAutoFix,
};
